@if (pageReady) {
  <main class="gs-page">
    <app-page-header [headerData]="pageHeader"></app-page-header>
    <div class="gs-page-inner">
      <div class="account-summary">
        <section class="gs-content-container">
          <div class="notification-container">
            <app-notification [pageName]="pageName"></app-notification>
          </div>
          <div class="payment-details-container">
            <div class="balance-details">
              <mat-card class="balance-card">
                <div class="card-content-container">
                  <div class="balance-container">
                    <mat-card-header>
                      <mat-card-title>
                        <h2 class="h3 account-balance-header" [innerHTML]="pageLabels.accountBalanceText"></h2>
                      </mat-card-title>
                    </mat-card-header>
                    @if (!accountDetail.IsAutoPay && !accountDetail.IsPayPlan) {
                      @if (accountDetail.PastDueBalance && accountDetail.PastDueBalance !== 0) {
                        @if (accountDetail.PastDueBalance !== accountDetail.CurrentBalance) {
                          <p class="balance-amount">
                            {{ accountDetail.CurrentBalance | currency | credit }}
                          </p>
                          <div class="due-date-container">
                            <p class="due-date-text" [innerHTML]="pageData.PastDueText"></p>
                            <div class="small-balance-text">{{ accountDetail.PastDueBalance | currency | credit }}</div>
                          </div>
                          @if (
                            accountDetail.CurrentBalance && accountDetail.PastDueBalance < accountDetail.CurrentBalance
                          ) {
                            <div class="due-date-container">
                              @if (accountDetail.CurrentBalance - accountDetail.PastDueBalance > 0) {
                                <p class="due-date-text" [innerHTML]="pageData.RemainingBalanceText"></p>
                                <div class="small-balance-text due-on-container">
                                  {{ accountDetail.CurrentBalance - accountDetail.PastDueBalance | currency | credit }}
                                  <p class="due-date-text">
                                    Due on {{ accountDetail.CurrentBalanceDueDate | date: "MM/dd/yyyy" }}
                                  </p>
                                </div>
                              }
                            </div>
                          }
                        } @else if (accountDetail.PastDueBalance === accountDetail.CurrentBalance) {
                          <p class="balance-amount">
                            {{ accountDetail.CurrentBalance | currency | credit }}
                          </p>
                          <div class="due-date-container">
                            <p class="due-date-text" [innerHTML]="pageData.DueImmediatelyText"></p>
                          </div>
                        }
                      } @else {
                        @if (accountDetail.CurrentBalance && accountDetail.CurrentBalance > 0) {
                          <p class="balance-amount">
                            {{ accountDetail.CurrentBalance | currency | credit }}
                          </p>
                          @if (dueDateDifference !== undefined) {
                            <div class="due-date-container">
                              @if (dueDateDifference === 0) {
                                <p class="due-date-text" [innerHTML]="pageData.DueTodayText"></p>
                              } @else if (dueDateDifference === -1) {
                                <p class="due-date-text" [innerHTML]="pageData.DueTomorrowText"></p>
                              } @else if (dueDateDifference < -1) {
                                <p class="due-date-text">
                                  Due By {{ accountDetail.CurrentBalanceDueDate | date: "MM/dd/yyyy" }}
                                </p>
                              }
                            </div>
                          }
                        } @else if (accountDetail.CurrentBalance === 0) {
                          <p class="balance-amount" [innerHTML]="pageData.ZeroBalanceText"></p>
                        } @else {
                          <p class="balance-amount">
                            {{ accountDetail.CurrentBalance | currency | credit }}
                          </p>
                        }
                      }
                      <!-- AutoPay -->
                    } @else if (accountDetail.IsAutoPay && accountDetail.AutoPay && !accountDetail.IsPayPlan) {
                      <!-- Display Balance -->
                      @if (
                        accountDetail.PastDueBalance && accountDetail.PastDueBalance !== accountDetail.CurrentBalance
                      ) {
                        <p class="balance-amount">
                          {{ accountDetail.CurrentBalance | currency | credit }}
                        </p>
                        <div class="due-date-container">
                          <p class="due-date-text" [innerHTML]="pageData.PastDueText"></p>
                          <div class="small-balance-text">{{ accountDetail.PastDueBalance | currency | credit }}</div>
                        </div>
                        @if (
                          accountDetail.CurrentBalance && accountDetail.PastDueBalance < accountDetail.CurrentBalance
                        ) {
                          <div class="due-date-container">
                            @if (accountDetail.CurrentBalance - accountDetail.PastDueBalance > 0) {
                              <p class="due-date-text" [innerHTML]="pageData.RemainingBalanceText"></p>
                              <div class="small-balance-text due-on-container">
                                {{ accountDetail.CurrentBalance - accountDetail.PastDueBalance | currency | credit }}
                                <p class="due-date-text">
                                  due on {{ accountDetail.CurrentBalanceDueDate | date: "MM/dd/yyyy" }}
                                </p>
                              </div>
                            }
                          </div>
                        }
                      } @else {
                        @if (accountDetail.CurrentBalance === 0) {
                          <p class="balance-amount" [innerHTML]="pageData.ZeroBalanceText"></p>
                        } @else if (accountDetail.CurrentBalance && accountDetail.CurrentBalance < 0) {
                          <p class="balance-amount">
                            {{ accountDetail.CurrentBalance | currency | credit }}
                          </p>
                        } @else {
                          <p class="balance-amount">
                            {{ accountDetail.CurrentBalance | currency }}
                          </p>
                        }
                      }
                      <!-- Display Account Message -->
                      <div class="autopay-text-container">
                        @if (pageData.autoPayDueDateMessage !== "" && pageData.autoPayDueDateMessage !== null) {
                          <p class="due-date-text" [innerHTML]="pageData.autoPayDueDateMessage"></p>
                        }
                        @if (pageData.autoPayMessage !== "" && pageData.autoPayMessage !== null) {
                          <p class="due-date-text" [innerHTML]="pageData.autoPayMessage"></p>
                        }
                        @if (
                          accountDetail.AutoPay.BankingAccountType !== null &&
                          accountDetail.AutoPay.PaymentAccountType === PaymentAccountType.Banking
                        ) {
                          <p class="due-date-text" [innerHTML]="pageData.BankAutoPayText"></p>
                        } @else if (
                          accountDetail.AutoPay.BankingAccountType === null &&
                          accountDetail.AutoPay.PaymentAccountType !== null
                        ) {
                          @if (
                            accountDetail.AutoPay.PaymentAccountType === PaymentAccountType.MasterCard ||
                            accountDetail.AutoPay.PaymentAccountType === PaymentAccountType.Visa ||
                            accountDetail.AutoPay.PaymentAccountType === PaymentAccountType.AmericanExpress ||
                            accountDetail.AutoPay.PaymentAccountType === PaymentAccountType.Discover
                          ) {
                            <p class="due-date-text" [innerHTML]="pageData.CardAutoPayText"></p>
                          } @else {
                            <p class="due-date-text" [innerHTML]="pageData.DigitalAutoPayText"></p>
                          }
                        }
                      </div>
                      <a
                        class="balance-change-autopay"
                        [attr.aria-label]="pageData.changeAutoPayAriaLabel"
                        [routerLink]="pageData.changeAutoPayUrl"
                        [innerHTML]="pageData.changeAutoPayLabel"
                      ></a>
                      <!-- PayPlan -->
                    } @else if (accountDetail.IsPayPlan || accountDetail.IsSevered) {
                      <p class="balance-amount">
                        {{ accountDetail.CurrentBalance | currency | credit }}
                      </p>
                      <div class="pay-plan-schedule">
                        @if (accountDetail.PayPlanType === "LIHEAP") {
                          <p class="payplan-active-header-text" [innerHTML]="pageLabels.energyAssistanceText"></p>
                        } @else {
                          <p class="payplan-active-header-text" [innerHTML]="pageLabels.payPlanScheduleText"></p>
                        }
                        @if (accountDetail.PaymentPlans && accountDetail.PaymentPlans.length > 1) {
                          <div class="installments-container">
                            @for (payment of accountDetail.PaymentPlans; let total = $count; track $index) {
                              @if (total <= 6) {
                                <p class="installment-balance-text">
                                  {{ payment.AmountDue | currency }} on {{ payment.DueDate | date: "MMM dd" }}
                                </p>
                              }
                            }
                          </div>
                        } @else if (accountDetail.PaymentPlans && accountDetail.PaymentPlans[0]) {
                          <div class="installments-container">
                            <p class="installment-balance-text">
                              {{ accountDetail.PaymentPlans[0].AmountDue | currency }} on
                              {{ accountDetail.PaymentPlans[0].DueDate | date: "MMM dd" }}
                            </p>
                          </div>
                        }
                      </div>
                    }
                    @if (accountDetail.FuturePayment && accountDetail.FuturePayment !== null && hasFuturePayment) {
                      <div class="pay-plan-schedule">
                        <p class="payplan-active-header-text" [innerHTML]="pageLabels.futurePaymentText"></p>
                        <div class="future-payment-container">
                          @if (
                            accountDetail.FuturePayment.Info?.PaymentDate &&
                            accountDetail.FuturePayment.Info?.PaymentAmount
                          ) {
                            <p class="installment-balance-text">
                              {{ accountDetail.FuturePayment.Info?.PaymentAmount | currency }} on
                              {{ accountDetail.FuturePayment.Info?.PaymentDate | date: "MMM dd" }}
                            </p>
                          }
                        </div>
                      </div>
                      <a
                        class="balance-change-autopay"
                        [attr.aria-label]="pageData.cancelFuturePaymentAriaLabel"
                        [routerLink]="pageData.cancelFuturePaymentURL"
                        [innerHTML]="pageData.cancelFuturePaymentLabel"
                      ></a>
                    }
                    @if (accountDetail.HeadlineCode !== "10") {
                      <a
                        class="make-payment-cta gs-link-btn"
                        [attr.aria-label]="pageData.payPlanAriaLabel"
                        [routerLink]="pageData.makeAPaymentURL"
                        [innerHTML]="pageData.makeAPaymentLabel"
                      ></a>
                    }
                    @if (accountDetail.IsEligibleForPayPlan === true) {
                      <a
                        class="make-payment-link"
                        [attr.aria-label]="pageData.payPlanAriaLabel"
                        [routerLink]="pageData.payPlanURL"
                        [innerHTML]="pageData.payPlanLabel"
                      ></a>
                    }
                  </div>
                  <mat-divider class="divider" [vertical]="!isMobile"></mat-divider>
                  <div class="view-bill-container">
                    @if (showFinalBillText) {
                      <p class="final-bill-text due-date-text" [innerHTML]="pageLabels.finalBillIsPresentText"></p>
                    } @else {
                      <p class="final-bill-text due-date-text" [innerHTML]="pageLabels.latestBillText"></p>
                    }
                    <i class="fa-thin fa-file-invoice-dollar fa-3x"></i>
                    @if (accountDetail.HeadlineCode !== "10") {
                      @if (viewBill && accountDetail.BillURL !== null) {
                        <a [href]="pageData.viewBillURL" [innerHTML]="pageLabels.viewBillLinkLabel" target="_blank"></a>
                      } @else if (!viewBill) {
                        <p class="due-date-text" [innerHTML]="pageLabels.notViewableBillText"></p>
                      }
                    } @else {
                      <p [innerHTML]="pageLabels.noBillReadyYet"></p>
                    }
                  </div>
                </div>
              </mat-card>
            </div>
            <div class="rate-plan-details">
              <p class="rate-plan-header">Your Plan</p>
              @if (accountDetail.ServiceAddressCount === 1 && accountDetail.CustomerClass === "LRGCOM") {
                <div class="rate-plan-details-container">
                  <p class="rate-plan-title" [innerHTML]="pageData.plan.planType"></p>
                  <p class="rate-plan-rate"><span class="rate-price" [innerHTML]="pageData.plan.billRate"></span></p>
                </div>
                @if (
                  showExpirationDate &&
                  accountDetail.BillingRateExpirationDate &&
                  !pageData.plan.planType.toUpperCase().includes("COMPLEX")
                ) {
                  <p class="rate-plan-expiration-header" [innerHTML]="pageLabels.planExpirationText"></p>
                  <p class="rate-plan-expiration">
                    {{ accountDetail.BillingRateExpirationDate | date: "MMM dd, yyyy" }}
                  </p>
                }
              } @else if (accountDetail.ServiceAddressCount === 1) {
                <div class="rate-plan-details-container">
                  <p class="rate-plan-title" [innerHTML]="pageData.plan.planType"></p>
                  <p class="rate-plan-rate"><span class="rate-price" [innerHTML]="pageData.plan.billRate"></span></p>
                </div>
                @if (
                  showExpirationDate &&
                  accountDetail.BillingRateExpirationDate &&
                  !pageData.plan.planType.toUpperCase().includes("COMPLEX")
                ) {
                  <div class="expiration-tooltip-container">
                    <p class="rate-plan-expiration-header" [innerHTML]="pageLabels.planExpirationText"></p>
                    <i
                      #tooltip="matTooltip"
                      [matTooltip]="pageData.toolTipRenew"
                      matTooltipPosition="below"
                      matTooltipClass="gs-tooltip"
                      (click)="$event.preventDefault(); $event.stopImmediatePropagation(); tooltip.toggle()"
                      (keydown.enter)="tooltip.toggle()"
                      tabindex="0"
                      [attr.aria-label]="pageData.toolTipRenew"
                      role="tooltip"
                      class="gs-tooltip-icon fa-solid fa-circle-question"
                    ></i>
                  </div>
                  <p class="rate-plan-expiration">
                    {{ accountDetail.BillingRateExpirationDate | date: "MMM dd, yyyy" }}
                  </p>
                }
                @if (!this.accountDetail.EligibileForRateChange && this.accountDetail.EligibileForRenewal) {
                  <a
                    [routerLink]="pageData.renewPlanURL"
                    [innerHTML]="pageData.renewPlanLabel"
                    [attr.aria-label]="pageData.renewPlanAriaLabel"
                  ></a>
                }
                @if (this.accountDetail.EligibileForRateChange) {
                  <a
                    [routerLink]="pageData.selectNewPlanURL"
                    [innerHTML]="pageData.selectNewPlanLabel"
                    [attr.aria-label]="pageData.selectNewPlanAriaLabel"
                  ></a>
                }
              } @else {
                <a
                  [routerLink]="pageData.viewPlansURL"
                  [innerHTML]="pageData.viewPlansLabel"
                  [attr.aria-label]="pageData.viewPlansAriaLabel"
                ></a>
              }
            </div>
            <div class="payment-settings">
              <app-billing-settings [data]="billSettingsData" [accountDetail]="accountDetail"></app-billing-settings>
            </div>
          </div>

          @if (showBannerAd && bannerAd) {
            <section
              class="banner-bulletin"
              [style.background-color]="bannerAd.fillColor"
              [style.color]="bannerAd.textColor"
              data-cy="summary-bulletin-banner"
              aria-label="Promotional offer"
            >
              <button
                class="banner-bulletin-close"
                type="button"
                aria-label="Close promotional offer"
                data-cy="btn-summary-bulletin-dismiss"
                (click)="dismissBannerAd()"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="banner-bulletin-image-container">
                <img class="banner-bulletin-image" [src]="bannerAd.image" [alt]="bannerAd.imageAlt" />
              </div>
              <div class="banner-bulletin-content">
                <p class="banner-bulletin-main-text" [style.color]="bannerAd.textColor">{{ bannerAd.mainText }}</p>
                <a
                  class="banner-bulletin-link"
                  [href]="bannerAd.linkUrl"
                  [attr.target]="bannerAd.openLinkInNewWindow ? '_blank' : null"
                  [attr.rel]="bannerAd.openLinkInNewWindow ? 'noopener noreferrer' : null"
                  [style.color]="bannerAd.textColor"
                  data-cy="link-summary-bulletin"
                >
                  <span>{{ bannerAd.linkText }}</span>
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </div>
            </section>
          }

          @if (featureTiles.length > 0) {
            <div class="features-container">
              @for (tile of featureTiles; track tile.header) {
                <a
                  class="feature"
                  [routerLink]="tile.link.value.data.url"
                  (click)="onFeatureTileClick()"
                  [attr.data-cy]="'link-summary-feature-' + $index"
                >
                  <div class="font-awesome-icon" [innerHTML]="tile.fontAwesomeIcon"></div>
                  <p class="feature-title" [innerHTML]="tile.header"></p>
                  <p class="feature-description" [innerHTML]="tile.description"></p>
                </a>
              }
            </div>
          }

          @if (blogs$ | async; as blogs) {
            <div class="blog-section">
              <div class="blog-section-title" [innerHTML]="pageLabels.blogsHeader"></div>
              <div class="blogs-container">
                @for (blog of blogs; track $index) {
                  <div class="blog">
                    <a [href]="env.blogBaseUrl + blog.data.url" target="_blank">
                      <img class="blog-thumbnail" [src]="blog.data.thumbNail" alt="Image for {{ blog.name }} blog" />
                    </a>
                    <div class="blog-desc">
                      <a [href]="env.blogBaseUrl + blog.data.url" target="_blank" [innerHTML]="blog.name"></a>
                      <p class="blog-date">{{ formatBlogDate(blog.data.date) }}</p>
                      <p class="blog-excerpt">{{ blog.data.excerpt }}</p>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </section>
      </div>
    </div>
  </main>
}
